import { createContext, useContext } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { useAuthorizedAxiosClient } from "../../../../common/axios"
import { isConcierge } from "../../../users/accountRole"
import { selectProfile, selectProfileLoaded } from "../../../users/reducer"
import useInboxNotifications from "./useInboxNotifications"

const EMPTY_INBOX = {
  counts: { voicemail: 0, email: 0, sms: 0, total: 0 },
  lists: { voicemail: [], email: [], sms: [] },
  status: { voicemail: "idle", email: "idle", sms: "idle" },
  refresh: () => {},
  clearChannel: async () => {},
  markSeenFromLists: () => {},
}

const InboxNotificationsContext = createContext(EMPTY_INBOX)

/**
 * Polls the inbox once for the whole layout. The navbar (rendered twice, for
 * desktop and mobile) and the sidebar Messages badge all read from here, so
 * there is a single poller and a single "new message" alert.
 */
export function InboxNotificationsProvider({ children }) {
  const profile = useSelector(selectProfile)
  const profileLoaded = useSelector(selectProfileLoaded)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const axios = useAuthorizedAxiosClient()
  const inbox = useInboxNotifications({
    axios,
    profile,
    profileLoaded,
    concierge: isConcierge(profile),
    dispatch,
    navigate,
  })
  return (
    <InboxNotificationsContext.Provider value={inbox}>
      {children}
    </InboxNotificationsContext.Provider>
  )
}

export function useInboxNotificationsContext() {
  return useContext(InboxNotificationsContext)
}
